import React, { FC, useEffect, useRef, useState } from "react";

import { FiSearch } from "react-icons/fi";
import { useOnClickOutSide } from "../../tools/hooks/click-outSide-handler";
import { filterDataAPI } from "../../services/CRUDServices";
import { filterUrls } from "../../services/api.enums";
import { useSelector } from "react-redux";

interface VehiclePelakSuggestProps {
  formik: any;
  WrapperClassName?: string;
  label?: string;
  important?: boolean;
  ReadOnly?: boolean;
  Search?: boolean;
  isSuggest?: boolean;
  url?: string;
  hasbody?: boolean;
}

const VehiclePelakSuggest: FC<VehiclePelakSuggestProps> = ({
  WrapperClassName,
  label = "شماره پلاک",
  important,
  ReadOnly,
  formik,
  Search,
  isSuggest,
  url,
  hasbody,
}): JSX.Element => {
  const WrapperRef = useRef(null);

  const [pelakOptions, setPelakOptions] = useState([]);
  const [isOpen, setisOpen] = useState(false);
  const { CurrentHub } = useSelector((state: any) => state.currentHubInfo);

  const { values, setFieldValue, Error }: any = formik;

  const closeModalHandler = (e: boolean) => {
    setisOpen(false);
  };
  useOnClickOutSide(WrapperRef, isOpen, closeModalHandler);
  const handleFetchPelakOptions = async (
    number0: number,
    number1: string,
    number2: number,
    number3: number
  ) => {
    try {
      const res = await filterDataAPI(
        url || filterUrls.findbycartagnumberSuggest,
        hasbody
          ? {
              carTagDto: {
                vehicleNumber0: number0,
                vehicleNumber1: number1,
                vehicleNumber2: number2,
                vehicleNumber3: number3,
              },
              date: values.vehiclePlanDate,
              selectType: values.triptype,
              selectHub: { id: CurrentHub.id, text: CurrentHub.label },
            }
          : {
              vehicleNumber0: number0,
              vehicleNumber1: number1,
              vehicleNumber2: number2,
              vehicleNumber3: number3,
            }
      );
      setPelakOptions(res.data.payload);
    } catch (error) {}
  };

  useEffect(() => {
    if (isSuggest) {
      handleFetchPelakOptions(
        values.vehicleNumber0,
        values.vehicleNumber1,
        values.vehicleNumber2,
        values.vehicleNumber3
      );
    }
  }, [
    values.vehicleNumber0,
    values.vehicleNumber1,
    values.vehicleNumber2,
    values.vehicleNumber3,
    isSuggest,
  ]);

  const handleSelect = (
    number0: number,
    number1: string,
    number2: number,
    number3: number,
    id: number
  ) => {
    setFieldValue("vehicleNumber0", number0);
    setFieldValue("vehicleNumber1", number1);
    setFieldValue("vehicleNumber2", number2);
    setFieldValue("vehicleNumber3", number3);
    setFieldValue("selectVehicle", { id: id, text: "" });
    setisOpen(false);
  };

  return (
    <div
      ref={WrapperRef}
      className={` relative autocompleteWrapper Max-md:w-full mb-6 wrapperResponsive ${WrapperClassName} ${
        Error && "border-red"
      }`}
    >
      <div className={` autocompleteLabel  ${Error && "text-red"} top-[-17px]`}>
        {label}
        <span className="text-tomato font-extrabold text-lg h-4">{important ? "*" : " "}</span>
      </div>
      <div
        className={`${
          isOpen ? "absolute" : "hidden"
        } w-full bg-white shadow-xl	 right-0 left-0 top-[45px]  flex flex-col z-20 overflow-auto max-h-60`}
      >
        {isSuggest &&
          pelakOptions.map((item: any) => (
            <button
              className="p-2 flex justify-evenly  hover:bg-gray-50 focus:bg-blue-200 "
              key={item?.id}
              onClick={() =>
                handleSelect(
                  item?.vehicleNumber0,
                  item?.vehicleNumber1,
                  item?.vehicleNumber2,
                  item?.vehicleNumber3,
                  item?.id
                )
              }
              type="button"
            >
              <span className="w-[25%]">{item.vehicleNumber3}</span>
              <span>&#8722;</span>
              <span className="w-[25%]">{item.vehicleNumber2}</span>
              <span>&#8722;</span>
              <span className="w-[25%]">{item.vehicleNumber1}</span>
              <span>&#8722;</span>
              <span className="w-[25%]">{item.vehicleNumber0}</span>
            </button>
          ))}
      </div>

      <input
        name="vehicleNumber3"
        type="number"
        placeholder="11"
        disabled={ReadOnly}
        maxLength={2}
        value={values.vehicleNumber3}
        className="w-[25%] border-b text-center focus:outline-none"
        onChange={(e) => {
          setisOpen(true);
          (twonumberLimmit.test(e.target.value) || e.target.value === "") &&
            setFieldValue("vehicleNumber3", e.target.valueAsNumber);
        }}
      />
      <span>&#8722;</span>
      <input
        name="vehicleNumber2"
        type="number"
        placeholder="111"
        disabled={ReadOnly}
        value={values.vehicleNumber2}
        maxLength={3}
        className="w-[25%] border-b text-center focus:outline-none"
        onChange={(e) => {
          setisOpen(true);
          (threenumberLimmit.test(e.target.value) || e.target.value === "") &&
            setFieldValue("vehicleNumber2", e.target.valueAsNumber);
        }}
      />
      <span>&#8722;</span>
      <input
        name="vehicleNumber1"
        placeholder="ب"
        disabled={ReadOnly}
        value={values.vehicleNumber1}
        maxLength={1}
        className="w-[25%] border-b text-center focus:outline-none"
        onChange={(e) => {
          setisOpen(true);
          (perSianLetter.test(e.target.value) || e.target.value === "") &&
            setFieldValue("vehicleNumber1", e.target.value);
        }}
      />
      <span>&#8722;</span>
      <input
        name="vehicleNumber0"
        type="number"
        placeholder="11"
        disabled={ReadOnly}
        value={values.vehicleNumber0}
        maxLength={3}
        pattern="([0-9][0-9])"
        className="w-[25%] border-b text-center focus:outline-none"
        onChange={(e) => {
          setisOpen(true);
          (twonumberLimmit.test(e.target.value) || e.target.value === "") &&
            setFieldValue("vehicleNumber0", e.target.valueAsNumber);
        }}
      />
      {Search && (
        <span className="pr-2 ">
          <FiSearch size={19} className="text-darkGray" />
        </span>
      )}
    </div>
  );
};
VehiclePelakSuggest.defaultProps = {
  WrapperClassName: "w-60",
};
export default VehiclePelakSuggest;

const perSianLetter = /^[\u0600-\u06FF\s]+$/;
const twonumberLimmit = /^[0-9]?[0-9]$/;
const threenumberLimmit = /^[0-9]?[0-9]?[0-9]$/;
